const teamsReducer = (state = [], action) => {
    switch (action.type) {
        case 'FETCH_TEAMS':
            return action.payload.items
        default:
            return state
    }
}

export default teamsReducer